/**
 * 統一エラーコード定義
 *
 * @file errorCodes.ts
 * @version 1.0.0
 * @author Japan4U Development Team
 * @summary
 * 購入者向け統一エラーページで使用するエラーコード定義。
 * エラーコードは管理者が原因特定するためのもので、ユーザーには詳細を表示しない。
 */

/**
 * エラーコードカテゴリー
 * 1XX: ページ関連
 * 2XX: 認証関連
 * 3XX: API関連
 * 4XX: ネットワーク関連
 * 5XX: サービス無効関連
 * 6XX: データ検証関連
 * 7XX: 外部連携関連
 * 8XX: システム内部関連
 */
export const ErrorCodes = {
  // ページ関連 (1XX)
  PAGE_NOT_FOUND: 'B10101',
  PAGE_LOAD_FAILED: 'B10102',
  COMPONENT_RENDER_ERROR: 'B10103',

  // 認証関連 (2XX)
  AUTH_REQUIRED: 'B20101',
  AUTH_INVALID_CREDENTIALS: 'B20102',
  AUTH_TOKEN_EXPIRED: 'B20103',
  AUTH_SESSION_EXPIRED: 'B20104',

  // API関連 (3XX)
  API_REQUEST_FAILED: 'B30101',
  API_TIMEOUT: 'B30102',
  API_INVALID_RESPONSE: 'B30103',
  API_SERVER_ERROR: 'B30104',

  // ネットワーク関連 (4XX)
  NETWORK_DISCONNECTED: 'B40101',
  NETWORK_TIMEOUT: 'B40102',
  DNS_RESOLUTION_FAILED: 'B40103',

  // サービス無効関連 (5XX)
  SERVICE_YAUCTION_DISABLED: 'B50101',
  SERVICE_MERCARI_DISABLED: 'B50102',
  SERVICE_MAINTENANCE: 'B50103',

  // データ検証関連 (6XX)
  VALIDATION_FAILED: 'B60101',
  DATA_NOT_FOUND: 'B60102',
  DATA_INVALID: 'B60103',

  // 外部連携関連 (7XX)
  STRIPE_PAYMENT_FAILED: 'B70101',
  PAYPAL_PAYMENT_FAILED: 'B70102',
  SHIPPING_API_FAILED: 'B70103',

  // システム内部関連 (8XX)
  DB_CONNECTION_FAILED: 'B80101',
  REDIS_CONNECTION_FAILED: 'B80102',
  STORAGE_ERROR: 'B80103',
} as const;

export type ErrorCode = typeof ErrorCodes[keyof typeof ErrorCodes];

/**
 * エラーコードからカテゴリーを取得
 */
export const getErrorCategory = (code: ErrorCode): string => {
  const categoryCode = code.slice(1, 4);
  const categories: Record<string, string> = {
    '101': 'ページ関連',
    '201': '認証関連',
    '301': 'API関連',
    '401': 'ネットワーク関連',
    '501': 'サービス無効関連',
    '601': 'データ検証関連',
    '701': '外部連携関連',
    '801': 'システム内部関連',
  };
  return categories[categoryCode] || '不明';
};

/**
 * エラーコードを表示形式にフォーマット
 */
export const formatErrorCode = (code: ErrorCode | string): string => {
  return `(${code})`;
};
